// extracted by mini-css-extract-plugin
export default {"itemContainer":"style_itemContainer__s8rBs","item":"style_item__rxWMe","title":"style_title__EElrZ"};